import { environment, salesforce_api } from "../../config";

const VERIFIER_STORAGE_KEY = "sf_pkce_code_verifier";

const isSandboxSalesforceDomain = (() => {
  try {
    return new URL(salesforce_api.domain).hostname.endsWith(".sandbox.my.salesforce.com");
  } catch {
    return false;
  }
})();

//NOTE: The production connected app does not require PKCE, only the sandbox
//      apps do. mrrEnv falls back to "development" when REACT_APP_MRR_ENVIRONMENT
//      is missing, so a sandbox Salesforce domain is also required. Both must
//      agree before PKCE touches the OAuth flow.
export const pkceEnabled = environment.mrrEnv !== "production" && isSandboxSalesforceDomain;

const base64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...Array.from(bytes)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");

/**
 * Creates a code verifier, holds it in sessionStorage for the round trip
 * through Salesforce, and returns the S256 challenge for /services/oauth2/authorize.
 * Returns null without touching storage when PKCE is disabled.
 */
export const createPkceChallenge = async () => {
  if (!pkceEnabled) {
    return null;
  }
  const verifier = base64Url(crypto.getRandomValues(new Uint8Array(32)));
  sessionStorage.setItem(VERIFIER_STORAGE_KEY, verifier);
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(verifier)
  );
  return base64Url(new Uint8Array(digest));
};

/**
 * Reads the stored verifier for the token exchange. A verifier is good for one
 * exchange only, so it is dropped as it is read.
 * Returns null without touching storage when PKCE is disabled.
 */
export const takePkceVerifier = () => {
  if (!pkceEnabled) {
    return null;
  }
  const verifier = sessionStorage.getItem(VERIFIER_STORAGE_KEY);
  sessionStorage.removeItem(VERIFIER_STORAGE_KEY);
  return verifier;
};
